export enum CaptureDetailsPrefixConstants {
    Individual = "individual",
    TaxPractitioner = "taxPractInfo",
    Delegate = "delegate",
    Representative = "registeredRepresentInfo",
    Taxpayer = "taxpayer"
}

export enum EntityTypes {
    Individual = "Individual",
    Company = "Company",
    Trust = "Trust",
    SMME = "SMME"
}

export enum RequestorType {
    Individual = "Individuals",
    SMMESoleProprietor = "SMME",
    TaxPractitioner = "Tax Practitioner",
    Representative = "Company/ Trust / Entity Representative", 
}

export enum BookingStatus {
    Booked = "Booked",
    AwaitingDocs = "AwaitingSupportingDocs"
}

export enum AvailabilityStatus {
    Available = "available",
    Full = "full",
    TaxPractitionerMaxBookings = "tax_practitioner_restricted"
}

export enum RequestorSubType {
    Individual = "Individual",
    SMME = "Individual",
    TaxPractitioner = "Tax Practitioner",
    RegisteredRepresentative = "Registered Representative",
    OnceOffMandate = "Once-off Mandate",
    TaxPractitionerDelegate = "Delegate of Tax Practitioner",
    RegisteredRepresentativeDelegate = "Delegate of Registered Representative"
}

export enum IDTypes {
    SAIdentificationNumber = "id_number",
    PassportNumber = "passport_number",
    AsylumSeeker = "asylum_seeker"
}

export enum BookingTypes {
    PopUp = "Pop-Up Branch",
    WalkIn = "Walk In",
    Mobile = "Mobile Tax Unit",
    VATRegistration = "VAT Registration Accreditation" 
}